import React, { createContext, useState, useContext } from "react";
import axios from "axios";

import { AuthContext } from "./AuthContext";

export const AdminContext = createContext();

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/";

const AdminContextProvider = (props) => {
  const { token, user, logout } = useContext(AuthContext);
  const [isNoteSaving, setIsNoteSaving] = useState(false);
  const [isDailyMessageSaving, setIsDailyMessageSaving] = useState(false);

  const [users, setUsers] = useState([]);
  const [myNotes, setMyNotes] = useState([]);
  const [dailyMessage, setdailyMessage] = useState([]);

  const saveMyNotes = (isInit = false, markup) => {
    if (isInit) {
      setIsNoteSaving(true);


      //Cancel axios request when component unmounted
      let source = axios.CancelToken.source();

      if (!isNoteSaving) {
        axios
          .post(
            API_URL + "save-mynotes",
            {
              who: user.username,
              note: markup,
            },
            {
              cancelToken: source.token,
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            setIsNoteSaving(false);
          })
          .catch((error) => {
            if (error.response) {
              setIsNoteSaving(false);
              logout();
            }


          });
      }

      //Cancel axios request when component unmounted
      return () => {
        setIsNoteSaving(false);
        source.cancel();
      };
    }
  };

  const getMyNotes = () => {
    //Cancel axios request when component unmounted
    let source = axios.CancelToken.source();

    axios
      .get(API_URL + "get-mynotes", {
        //Cancel axios request when component unmounted
        cancelToken: source.token,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {



        setMyNotes(res.data.notes);
      })
      .catch((error) => {
        if (error.response) {



          logout();
        }


      });

    //Cancel axios request when component unmounted
    return () => {
      source.cancel();
    };
  };

  const saveDailyMessage = (isInit = false, message) => {
    if (isInit) {
      setIsDailyMessageSaving(true);


      //Cancel axios request when component unmounted
      let source = axios.CancelToken.source();

      if (!isNoteSaving) {
        axios
          .post(
            API_URL + "save-dailyMessage",
            {
              who: user.username,
              message: message,
            },
            {
              cancelToken: source.token,
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((res) => {
            setIsDailyMessageSaving(false);
          })
          .catch((error) => {
            if (error.response) {
              setIsDailyMessageSaving(false);
              logout();
            }


          });
      }

      //Cancel axios request when component unmounted
      return () => {
        setIsDailyMessageSaving(false);
        source.cancel();
      };
    }
  };

  const getDailyMessage = () => {
    //Cancel axios request when component unmounted
    let source = axios.CancelToken.source();

    axios
      .get(API_URL + "get-dailyMessage", {
        //Cancel axios request when component unmounted
        cancelToken: source.token,
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        setdailyMessage(res.data.daily_message);
      })
      .catch((error) => {
        if (error.response) {
          logout();
        }


      });

    //Cancel axios request when component unmounted
    return () => {
      source.cancel();
    };
  };

  const loadUsers = (active = false) => {
    //Cancel axios request when component unmounted
    let source = axios.CancelToken.source();

    axios
      .post(
        API_URL + "get-users",
        {
          active: active,
        },
        {
          //Cancel axios request when component unmounted
          cancelToken: source.token,
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((res) => {



        setUsers(res.data.users);
      })
      .catch((error) => {
        if (error.response) {
          // Don't logout for 403 - it just means user doesn't have permission to view all users
          // Only logout for auth errors (401)
          if (error.response.status === 401) {
            logout();
          }
          // For 403, silently fail - users list will remain empty
        }


      });

    //Cancel axios request when component unmounted
    return () => {
      source.cancel();
    };
  };

  return (
    <AdminContext.Provider
      value={{
        loadUsers,
        users,
        saveMyNotes,
        getMyNotes,
        myNotes,
        isNoteSaving,
        saveDailyMessage,
        getDailyMessage,
        dailyMessage,
        isDailyMessageSaving,
      }}
    >
      {props.children}
    </AdminContext.Provider>
  );
};

export default AdminContextProvider;
